<template>
    <div>
        <van-nav-bar      left-text="返回" @click-left="back"    left-arrow/>
        <div class='pt46'>
            <img :src="webUrl+baseInfo.product_img" width='100%' height='250' alt="">
            <van-cell clickable :title="baseInfo.node"  :label="baseInfo.name" />
            <van-cell @click='showVariety = true'   is-link  title="品种介绍:"  :label="baseInfo.variety" />
            <van-cell @click='showEnvironment = true'   is-link  title="生长环境:"  :label="baseInfo.environment" />
            <van-cell clickable title="采摘时间" :value="baseInfo.pick_time == '' ? '暂无' : baseInfo.pick_time"  />
            <van-cell clickable title="查询次数"  :value="baseInfo.qrcode_num == '' ?'暂无' : baseInfo.qrcode_num"/>
        </div>


        <van-popup  v-model="showEnvironment"  closeable  position="bottom"  :style="{ height: '40%' }">
            <div v-if="baseInfo.environment !=''" class="popupBox">
                {{baseInfo.environment}}
            </div>
            <div class="popupBox" v-else>暂无</div>
            
        </van-popup>

        <van-popup  v-model="showVariety"  closeable  position="bottom"  :style="{ height: '40%' }">
             <div v-if="baseInfo.showVariety !=''" class="popupBox">
                {{baseInfo.variety}}
            </div>
            <div class="popupBox" v-else>暂无</div>
        </van-popup>

    </div>
</template>
<script>
import {getBaseShow,getBaseAgricultural,getBaseImg} from '@/request/data'
export default {
    name:'traceability',
    data() {
        return {
            webUrl:this.$store.state.imgURL,
            baseInfo:[],
            showEnvironment:false,
            showVariety:false,
        }
    },
    mounted() {
        this.$toast({
            type:'loading',
            message:'加载中...',
            duration: 0,
            forbidClick: true, // 禁用背景点击
        });
        this.getBaseShow()
    },
    methods: {
        getBaseShow(){
            let id = this.$route.query.id
            getBaseShow(id).then(res=>{
                this.$toast.clear()
                if (res.data.code == 0) {
                    this.baseInfo = res.data.data
                }
                console.log(res.data.data)
            })
            
        },
        back(){
            this.$router.back(-1)
        }
    },
}
</script>

<style  scoped>
.van-cell__label{height:20px;overflow:hidden}
.popupBox{padding:45px 15px 15px;font-size:14px;line-height:22px}
</style>